<template>
  <div :class="['d-flex', alignClass]">
    <v-btn
      v-bind="$attrs"
      v-on="$listeners"
      :class="[
        'button-widget px-8 font-weight-regular text-none',
        secondary && 'grey--text text--darken-4',
      ]"
      :color="color ? color : !secondary ? 'primary' : 'secondary'"
      :type="type"
      :height="height"
      rounded
      depressed
    >
      <slot />
    </v-btn>
  </div>
</template>

<script>
export default {
  props: {
    align: {
      type: String,
      default: "left",
      validator: (val) => ["left", "center", "right"].includes(val),
    },
    height: {
      type: String,
      default: "48px",
    },
    color: {
      type: String,
      default: "",
    },
    secondary: {
      type: Boolean,
      default: false,
    },
    type: {
      type: String,
      default: "button",
    },
  },
  computed: {
    alignClass() {
      const classes = {
        left: "justify-start",
        center: "justify-center",
        right: "justify-end",
      };

      return classes[this.align];
    },
  },
};
</script>

<style>
.button-widget {
  font-size: 18px !important;
  letter-spacing: initial;
}
</style>
